<template>
  <v-container grid-list-xl fluid text-xs-center pa-0 mt-3>
    <v-layout row xs12 wrap>
      <v-flex xs12 md3>
        <v-card>
          <v-card-text>
            <v-progress-circular
              :rotate="-90"
              :size="150"
              :width="25"
              :value="progress.password"
              color="teal lighten-1"
              class="headline ma-5"
            >{{progress.password}}%</v-progress-circular>
          </v-card-text>
          <small>des étudiants ont un compte EduID</small>
        </v-card>
      </v-flex>
      <v-flex xs12 md3>
        <v-card text-xs-center>
          <v-card-text>
            <v-progress-circular
              :rotate="-90"
              :size="150"
              :width="25"
              :value="progress.codeOfConduct"
              color="teal lighten-1"
              class="headline ma-5"
            >{{progress.codeOfConduct}}%</v-progress-circular>
          </v-card-text>
          <small>des étudiants ont accepté le code de savoir-vivre</small>
        </v-card>
      </v-flex>
      <v-flex xs12 md2>
        <v-card>
          <v-card-text>
            <v-progress-circular
              :rotate="-90"
              :size="150"
              :width="25"
              :value="progress.ahes"
              color="teal lighten-1"
              class="headline ma-5"
            >{{progress.ahes}}%</v-progress-circular>
          </v-card-text>
          <small>des étudiants ont complété le questionnaire AHES</small>
        </v-card>
      </v-flex>
      <v-flex xs12 md2>
        <v-card>
          <v-card-text>
            <v-progress-circular
              :rotate="-90"
              :size="150"
              :width="25"
              :value="progress.equivalency"
              color="teal lighten-1"
              class="headline ma-5"
            >{{progress.equivalency}}%</v-progress-circular>
          </v-card-text>
          <small>des étudiants souhaitent faire une demande d'équivalence pour les cours</small>
        </v-card>
      </v-flex>
      <v-flex xs12 md2>
        <v-card>
          <v-card-text>
            <v-progress-circular
              :rotate="-90"
              :size="150"
              :width="25"
              :value="progress.langEquivalency"
              color="teal lighten-1"
              class="headline ma-5"
            >{{progress.langEquivalency}}%</v-progress-circular>
          </v-card-text>
          <small>des étudiants ont effectué leur choix pour les demandes d'équivalence pour les langues</small>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ['stats'],
  mounted() {
    this.timeout = setTimeout(() => {
      this.progress = this.stats;
    }, 100);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  data: () => ({
    timeout: undefined,
    progress: {
      ahes: 0,
      password: 0,
      codeOfConduct: 0,
      equivalency: 0
    }
  })
};
</script>



